import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { inject, observer } from 'mobx-react';

const styles = theme => ({
  logoImageWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  largerLogoImage: {
    width: 50,
    height: 50,
  },
  facebookPageName: {
    paddingLeft: 15,
    fontSize: 20,
    color: '#076BD1',
    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
    },
  },
});

const StoreLogo = ({ classes, facebookPageName, facebookPageId }) => {
  return (
    <a
      href={`https://www.facebook.com/${facebookPageId}`}
      className={classes.sellerLink}
      target="_blank"
      rel="noreferrer"
    >
      <div className={classes.logoImageWrapper}>
        <Avatar
          src={`https://graph.facebook.com/${facebookPageId}/picture?height=120&width=120`}
          className={classes.largerLogoImage}
        />
        <span className={classes.facebookPageName}>
          <b>{facebookPageName}</b>
        </span>
      </div>
    </a>
  );
};

StoreLogo.propTypes = {
  classes: PropTypes.object.isRequired,
  facebookPageName: PropTypes.string,
  facebookPageId: PropTypes.string,
};

export default withStyles(styles)(StoreLogo);
